<template>
<div class="in-report-manage">
    <component :is="views" @goEdit="goEdit"></component>
</div>
</template>

<script>
import kzList from '@/views/KZGL/components/kzList';
export default {
    data() {
        return {
            views: kzList
        }
    },
    methods: {  
        goEdit(){
            
        }
    },
    mounted() {
    }
}
</script>
